<script>
import MemberRepository from '../../../js/repository/MemberRepository';

// the hand scanner's prefix for barcodes is configured to be "|#1" with german Windows keyboard layout
// the nfc reader's prefix is configured to be "!#1" with german Windows keyboard layout
// we could not use the same prefix for the nfc reader, because it does not support the "|" character

const prefixes = [
    // linux
    // [225, 220, 191, 49], // |#1 qr code
    // [16, 49, 191, 49], // !#1 nfc

    // windows - windows seems to simply ignore key modifiers
    [226, 191, 49], // |#1 qr code
    [49, 191, 49], // !#1 nfc
];

export default {
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        accessMediumScannedAsEvent: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            prefixBuffer: [],
            accessMediumIdentifier: [],
        };
    },
    computed: {
        hasAccessMediumIdentifier() {
            return this.accessMediumIdentifier.length > 0;
        },
        hasCorrectPrefix() {
            return prefixes.some((prefix) => prefix.join('|') === this.prefixBuffer.join('|'));
        },
    },
    created() {
        const checkForScannerInput = (e) => this.checkForScannerInput(e);

        document.addEventListener('keyup', checkForScannerInput);
        this.$once('hook:destroyed', () => document.removeEventListener('keyup', checkForScannerInput));
    },
    methods: {
        checkForScannerInput(event) {
            const key = event.key;
            const keyCode = event.keyCode;

            if (this.hasAccessMediumIdentifier && this.hasCorrectPrefix && keyCode === 13) {
                MemberRepository
                    .findMemberInfosByAccessMediumIdentifier(this.clubId, this.accessMediumIdentifier.join(''))
                    .then((infos) => this.handelMemberInfos(infos))
                    .catch(() => this.$notify.error('Es konnte kein Mitglied für das angegebene Zutrittsmedium gefunden werden.'));

                this.accessMediumIdentifier = [];
                this.prefixBuffer = [];

                return;
            }

            if (this.hasCorrectPrefix && key.match(/^\d$/)) {
                this.accessMediumIdentifier.push(key);

                return;
            }

            if (prefixes.some((prefix) => prefix.indexOf(keyCode) !== -1)) {
                this.prefixBuffer.push(keyCode);

                if (prefixes.every((prefix) => prefix.join('|').indexOf(this.prefixBuffer.join('|')) === -1)) {
                    this.prefixBuffer = [keyCode];
                }
            }
        },
        handelMemberInfos(infos) {
            if (this.accessMediumScannedAsEvent) {
                this.$emit('accessMediumScanned', infos.memberId);
                return;
            }

            window.location = infos.shortProfileUrl;
        },
    },
    render() {
    },
};
</script>
